import React from "react";
import { XMarkIcon, PencilSquareIcon, HeartIcon } from "@heroicons/react/24/outline";

export default function PartnershipView({ isOpen, onClose, partnership, onEdit }) {
  if (!isOpen || !partnership) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-6 py-4">
          <h2 className="flex items-center text-lg font-semibold text-gray-800">
            <HeartIcon className="w-5 h-5 mr-2 text-blue-500" />
            Partnership Information
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 bg-gray-50 rounded-lg">
          <div className="grid grid-cols-2 gap-y-4 gap-x-8">
            <div>
              <p className="text-sm font-medium text-gray-500">Institution</p>
              <p className="text-gray-800">{partnership.institution?.name || "N/A"}</p>
            </div>

            <div>
              <p className="text-sm font-medium text-gray-500">Partner Name</p>
              <p className="text-gray-800">{partnership.partner_name || "N/A"}</p>
            </div>

            <div>
              <p className="text-sm font-medium text-gray-500">Type of Collaboration</p>
              <p className="text-gray-800">
                {typeof partnership.agreement_title === "object"
                  ? partnership.agreement_title?.name || "N/A"
                  : partnership.agreement_title || "N/A"}
              </p>
            </div>

            <div>
              <p className="text-sm font-medium text-gray-500">Status</p>
              <p className={`text-sm font-semibold ${
                partnership.status?.toLowerCase() === "active"
                  ? "text-green-700"
                  : "text-gray-600"
              }`}>
                {partnership.status || "N/A"}
              </p>
            </div>

            <div>
              <p className="text-sm font-medium text-gray-500">Start Date</p>
              <p className="text-gray-800">{partnership.start_date || "N/A"}</p>
            </div>

            <div>
              <p className="text-sm font-medium text-gray-500">End Date</p>
              <p className="text-gray-800">{partnership.end_date || "N/A"}</p>
            </div>

            <div className="col-span-2">
              <p className="text-sm font-medium text-gray-500">Remarks</p>
              <p className="text-gray-800">{partnership.remarks || "N/A"}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end border-t px-6 py-4">
          <button
            onClick={onEdit}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
          >
            <PencilSquareIcon className="w-4 h-4" />
            Edit Partnership Details
          </button>
        </div>
      </div>
    </div>
  );
}
